export default "__VITE_ASSET__gDi0k9xM__"